import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { useEnvironment } from "./useEnv";
import utils, { getCookie, handleApiFetch, initFetchWeb } from "../utils";

const infoContext = createContext<any>(null);
export const useInfo: () => ProviderUtils = () => {
    return useContext(infoContext)
}

interface ProviderUtils {
    info: Record<string, any> | null,

    fetchWeb: (path: string, init?: initFetchWeb | null, isJSON?: boolean, handleError?: boolean, developmentMode?: boolean) => Promise<any>
    fetchLogin: (username: string, password: string) => Promise<boolean>
    logout: () => boolean
}

export function InfoProvider({ children, preloadedInfo = undefined }: { children: ReactNode, preloadedInfo?: Record<string, any> }) {
    const env = {
        ...(typeof window !== "undefined" ? window.__env : {} ),
        ...useEnvironment()
    };

    const [info, setInfo] = useState<Record<string, any> | null>(preloadedInfo || null); // Account information (if null then user not logged in)

    async function fetchWeb(
        path = "/",
        init: initFetchWeb | null = null,
        isJSON = true,
        handleError = true
    ) {
        return handleApiFetch(env, path, init, info, isJSON, handleError);
    }

    async function fetchLogin(username: string, password: string) {
        const response = await fetchWeb('/users', {
            method: "POST",
            data: { username, password }
        })
        if (response == null || response['errorCode']) return false

        const myDate = new Date();
        myDate.setMonth(myDate.getMonth() + 12);
        document.cookie = `token=${response.token};expires=${myDate.toUTCString()}${env["development"] == true ? "" : ";domain=.angeldav.net;"}`
        setInfo(response)
        return true
    }

    async function getDataFromToken() {
        if (preloadedInfo) return;

        const token = getCookie(document.cookie, "token")
        if (token == null || token == "") return;

        const response = await fetchWeb('/users', {
            method: "POST",
            data: { token }
        })
        if (response == null || response['errorCode']) return

        const myDate = new Date();
        myDate.setMonth(myDate.getMonth() + 12);
        document.cookie = `token=${response.token};expires=${myDate}${env["development"] == true ? "" : ";domain=.angeldav.net;"}`
        setInfo(response)
    }
    
    function logout() {
        const myDate = new Date(0);
        document.cookie = `token=;expires=${myDate}${env["development"] == true ? "" : ";domain=.angeldav.net;"}`
        setInfo(null)
        return true
    }

    useEffect(() => {
        getDataFromToken()
    }, [])

    const exportUtils: ProviderUtils = {
        info: env.isClient ? info : (preloadedInfo || null),
        fetchWeb, fetchLogin, logout
    }

    return <infoContext.Provider value={exportUtils}>
        {children}
    </infoContext.Provider>
}